const zh_CN = {
  cancel: '取消',
  confirm: '确认',
  please_open_in_imtoken: '请在 imToken 中打开',
  update_app_title: '升级至 imToken 最新版本',
  update_app_desc: '由于当前 imToken 版本过低，无法使用该应用。请使用系统浏览器访问 https://token.im 升级 imToken。',
  no_wallet_title: '未发现钱包',
  no_wallet_desc: '请检查',
  understood: '知道了',
  energy: '能量',
  bandwidth: '带宽',
  freeze: '冻结',
  unfreeze: '解冻',
  resource: '资源',
  self: '自己',
  others: '他人',
  receiver: '接收方',
  receiver_address: '接收地址',
  freeze_amount: '冻结数量',
  resource_type: '资源类型',
  please_enter_freeze_amount: '请填写冻结数量',
  invalid_freeze_amount: '冻结数量不正确',
  invalid_receiver: '接受地址不正确',
  freeze_amount_less_than_1: '冻结数量不能小于 1 TRX',
  can_more_than_6_decimal: '不能超过 6 位小数',
  not_time_to_unfreeze: '未到解冻时间',
  packing: '交易确认中',
  freeze_success: '冻结成功',
  unfreeze_success: '解冻成功',
  how_freeze_and_unfreeze: '如何冻结与解冻',
  unfreeze_after_3_days: '注: 冻结三天后才可以解冻',
  wait_time_to_unfreeze: '注: 等待 $s 后才可以解冻',
  unfreezeable: '待解冻',
  freeze_migration_tip: '受 Tron 网络升级 Stake 2.0 影响，暂停冻结服务。可前往官方 DApp 进行冻结操作。',
  unfreeze_v1_staked_trx: '解冻 V1 质押的 TRX',
  link_justlend_desc: '官方能量租赁服务',
  link_feeeio_desc: '立省 70% 矿工费',
  link_resource_management_desc: '前往 DAppso 管理 TRON 资源',
  title_rent_resource: '租赁资源',
}

export default zh_CN
